const PAYMENT_STATUS_META = {
  paid: { label: "Pago", className: "status-paid", color: "green" },
  pending: { label: "Pendente", className: "status-pending", color: "orange" },
  overdue: { label: "Em Atraso", className: "status-overdue", color: "red" },
  failed: { label: "Falhou", className: "status-failed", color: "error" },
  canceled: { label: "Cancelado", className: "status-canceled", color: "default" },
};

const SUBSCRIBER_STATUS_META = {
  paid: { label: "Ativo", className: "status-active", color: "green" },
  pending: { label: "Pendente", className: "status-pending", color: "orange" },
  overdue: { label: "Em Atraso", className: "status-overdue", color: "red" },
  failed: { label: "Falhou", className: "status-failed", color: "error" },
  canceled: { label: "Cancelado", className: "status-canceled", color: "default" },
};

const PAYMENT_METHOD_LABELS = {
  credit_card: "Cartão de Crédito",
  boleto: "Boleto",
  pix: "PIX",
};

const OPEN_PAYMENT_STATUSES = ["pending", "failed", "overdue"];

const FREQUENCY_NOUNS = {
  weekly: "semana",
  biweekly: "quinzena",
  monthly: "mês",
  bimonthly: "bimestre",
  quarterly: "trimestre",
  semiannual: "semestre",
  annual: "ano",
};

const unknownStatusMeta = (status) => ({
  label: status,
  className: "",
  color: "default",
});

export const paymentStatusMeta = (status) =>
  PAYMENT_STATUS_META[status] || unknownStatusMeta(status);

export const subscriberStatusMeta = (status) =>
  SUBSCRIBER_STATUS_META[status] || unknownStatusMeta(status);

export const paymentMethodLabel = (method) =>
  PAYMENT_METHOD_LABELS[method] || method;

export const frequencyNoun = (frequency) =>
  FREQUENCY_NOUNS[frequency] || frequency;

export const isPaymentOpen = (status) => OPEN_PAYMENT_STATUSES.includes(status);

export const isPaymentPayable = (status, subscriberStatus) =>
  isPaymentOpen(status) && subscriberStatus !== "canceled";

export const planAllowsMethod = (paymentMethods, method) =>
  (paymentMethods || []).some((entry) => String(entry).toLowerCase() === String(method).toLowerCase());
